import axios from 'axios'
import {
  FILE_UPLOAD_PROGRESS,
  FILE_UPLOAD_ERROR,
  FILE_UPLOAD_RESPONSE,
  FILE_UPLOAD_LOADING,
  RESET_FILE_UPLOAD,
} from './types'

export const uploadAction = file => dispatch => {
  dispatch(setUploadLoading())

  const progress = {
    onUploadProgress: progress => {
      var complete = Math.round(progress.loaded * 100) / progress.total
      dispatch({ type: FILE_UPLOAD_PROGRESS, payload: complete })
    },
  }

  axios
    .post('/api/uploads', file, progress)
    .then(response => {
      dispatch({ type: FILE_UPLOAD_RESPONSE, payload: response.data })
    })
    .catch(error => {
      dispatch({ type: FILE_UPLOAD_ERROR, payload: error?.response?.data || error })
      console.log(error)
    })
}

export const setUploadLoading = () => dispatch => {
  return dispatch({ type: FILE_UPLOAD_LOADING })
}

export const resetUploadAction = () => dispatch => {
  dispatch({ type: RESET_FILE_UPLOAD })
}
